import type { ChangeEvent, KeyboardEvent } from 'react';
import React from 'react';
import { Box, Select } from '../index';
import moment from 'moment';
import 'moment-timezone';

interface SelectOption {
  id: number;
  value: string;
  label: string;
  name: string;
  disabled: boolean;
  description: string;
}

const timeZoneNames = moment.tz.names();
const timeZoneOptions = timeZoneNames.map<SelectOption>((tz, i) => ({
  id: i,
  value: tz,
  label: tz,
  name: tz,
  disabled: false,
  description: '',
}));

const TimeZoneInput = ({
  value,
  disabled = false,
  onChange,
  onKeyPress,
}: {
  value: string;
  disabled?: boolean;
  onChange: (timeZone: string) => void;
  onKeyPress?: (event: KeyboardEvent<HTMLElement>) => void;
}): JSX.Element => {
  const onInputChange = (value: string): void => {
    onChange(value);
  };

  const onInputKeyPress = (event: KeyboardEvent<HTMLSelectElement>): void => {
    onKeyPress?.(event);
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      width={180}
      height={32}
      color="input.text"
      fontSize={2}
      borderWidth={1}
      borderColor="input.border"
      borderStyle="solid"
    >
      <Select
        options={timeZoneOptions}
        disabled={disabled}
        defaultValue={value || 'UTC'}
        onChange={(event: ChangeEvent<HTMLSelectElement>) =>
          onInputChange(String(event.target.value))
        }
        onBlur={(event: ChangeEvent<HTMLSelectElement>) =>
          onInputChange(String(event.target.value))
        }
        onKeyDown={onInputKeyPress}
        height={30}
        border="none"
        textAlign="right"
        py={2}
        pr={2}
        pl={3}
      />
    </Box>
  );
};

export default TimeZoneInput;
